import {
  IonAlert,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonDatetime,
  IonDatetimeButton,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonModal,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonText,
  IonTitle,
  IonToast,
  IonToggle,
  IonToolbar,
} from "@ionic/react";
import { checkmarkCircleOutline, closeOutline, star } from "ionicons/icons";
import moment from "moment";
import React, {
  Fragment,
  memo,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { debounce, isEmpty } from "underscore";
import { v4 as uuidv4 } from "uuid";
import config from "../../../components/helpers/socket/config";
import { pubsubEvents } from "../../../components/helpers/socket/pubsubEvent";
import { hapticsImpactMedium } from "../../../utils/core-utils/hapticUtils";
import { saveUserPreferences } from "../../../utils/core-utils/preferenceUtils";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import {
  FractionalToDecimalConverter,
  validatePrice,
} from "../common/utils/FractionalToDecimalConverterAndValidator";
import UserPrefencesContext, {
  UserPreferences,
} from "./../../../components/contexts/UserPreferencesContext";
import { CMEDPermissions } from "./MarketDataContent";
import TickComponent from "./TickComponent";
import config_mktData from "./config_mktData";

import {
  MetricConstants,
  MetricTypeConstants,
} from "../../../components/Constants";
import { startMetric } from "../../../utils/metric-utils/metricUtils";
import { DecimalToFractionalConverter } from "../common/utils/DecimalToFractionalConverterAndValidator";
import { PriceErrorConstants } from "../common/utils/PriceErrorConstants";
import { QuantityErrorConstants } from "../common/utils/QuantityErrorConstants";
import { PriceRegexValidator } from "../common/utils/PriceRegexValidator";
import { parseTickGroupString } from "../common/utils/parseTickGroupString";
import {
  formatPriceForScreen,
  removeCommasOnFocus,
} from "../common/utils/priceInputUtils";
import Skeleton__OrderEntryModal from "./Skeleton__OrderEntryModal";
import EmptyTickComponent from "../common/components/EmptyTickComponent";
import expandIcon from "../../../theme/custom-icons/expand_more.svg";
import EmptyDateComponent from "../common/components/EmptyDateComponent";
import {
  getLastTwoWords,
  getModifiedContractName,
} from "../../../utils/commonUtils";
import { useAppPref } from "../../../components/providers/AppPrefProvider";

/**
 * @author
 * E42303 Judhjit Ganguli
 * E45597 Aryamitra Chaudhuri
 */

const QUANTITY_LIMITS = {
  MIN: 1,
  MAX: 99999,
};

// Utility function for resting price

//// price value utility function /////

const restingPriceBidOption = (orderEntryData: any) => {
  if (orderEntryData?.b?.r > 0 || orderEntryData?.b?.r < 0)
    return orderEntryData?.b?.f;
  else if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.f;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.f;
  else return "0";
};

const restingPriceOfferOption = (orderEntryData: any) => {
  if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.f;
  else if (orderEntryData?.b?.r > 0 || orderEntryData?.b?.r < 0)
    return orderEntryData?.b?.f;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.f;
  else return "0";
};

const restingPriceBidOthers = (orderEntryData: any) => {
  if (orderEntryData?.bb?.r > 0 || orderEntryData?.bb?.r < 0)
    return orderEntryData?.bb?.f;
  else if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.f;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.f;
  else return "0";
};

const restingPriceOfferOthers = (orderEntryData: any) => {
  if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.f;
  else if (orderEntryData?.bb?.r > 0 || orderEntryData?.bb?.r < 0)
    return orderEntryData?.bb?.f;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.f;
  else return "0";
};

///***End*************** */

////// Raw price value Utility function //////////////////

const restingRawPriceBidOption = (orderEntryData: any) => {
  if (orderEntryData?.b?.r > 0 || orderEntryData?.b?.r < 0)
    return orderEntryData?.b?.r;
  else if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.r;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.r;
  else return 0;
};

const restingRawPriceOfferOption = (orderEntryData: any) => {
  if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.r;
  else if (orderEntryData?.b?.r > 0 || orderEntryData?.b?.r < 0)
    return orderEntryData?.b?.r;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.r;
  else return 0;
};

const restingRawPriceBidOthers = (orderEntryData: any) => {
  if (orderEntryData?.bb?.r > 0 || orderEntryData?.bb?.r < 0)
    return orderEntryData?.bb?.r;
  else if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.r;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.r;
  else return 0;
};

const restingRawPriceOfferOthers = (orderEntryData: any) => {
  if (orderEntryData?.bo?.r > 0 || orderEntryData?.bo?.r < 0)
    return orderEntryData?.bo?.r;
  else if (orderEntryData?.bb?.r > 0 || orderEntryData?.bb?.r < 0)
    return orderEntryData?.bb?.r;
  else if (orderEntryData?.l?.r > 0 || orderEntryData?.l?.r < 0)
    return orderEntryData?.l?.r;
  else return 0;
};

//////////******** End***** */

type OrderEntryProps = {
  openOrderEntryModal: boolean;
  type: string;
  setOpenOrderEntryModal: any;
  orderEntryData: any;
  orderEntryType: string | undefined;
  userCMEDEntitlements: CMEDPermissions | undefined;
  componentusedIn: string; //optionsGrid, marketData
  selectedOption: any;
  priceType: any;
  setpriceType: any;
  orderEntryData_Live: any;
};

const OrderEntryModal: React.FC<OrderEntryProps> = ({
  openOrderEntryModal,
  setOpenOrderEntryModal,
  orderEntryData,
  orderEntryType,
  userCMEDEntitlements,
  type,
  componentusedIn,
  selectedOption,
  priceType,
  setpriceType,
  orderEntryData_Live,
}) => {
  const { isOrderEntryOpenedFromMain, setIsOrderEntryOpenedFromMain } =
    useAppPref();

  //////////////Utility Function for raw price and basic price////////////

  const basicPrice = (
    orderEntryType: any,
    orderEntryData: any,
    type: any,
    userCMEDEntitlements: any,
  ) => {
    return type === "options"
      ? orderEntryType === "bid"
        ? userCMEDEntitlements?.agressiveOrderIndicator === true &&
          isOrderEntryOpenedFromMain
          ? restingPriceOfferOption(orderEntryData)
          : restingPriceBidOption(orderEntryData)
        : userCMEDEntitlements?.agressiveOrderIndicator === true &&
            isOrderEntryOpenedFromMain
          ? restingPriceBidOption(orderEntryData)
          : restingPriceOfferOption(orderEntryData)
      : orderEntryType === "bid"
        ? userCMEDEntitlements?.agressiveOrderIndicator === true &&
          isOrderEntryOpenedFromMain
          ? restingPriceOfferOthers(orderEntryData)
          : restingPriceBidOthers(orderEntryData)
        : userCMEDEntitlements?.agressiveOrderIndicator === true &&
            isOrderEntryOpenedFromMain
          ? restingPriceBidOthers(orderEntryData)
          : restingPriceOfferOthers(orderEntryData);
  };

  const rawPrice = (
    orderEntryType: any,
    orderEntryData: any,
    type: any,
    userCMEDEntitlements: any,
  ) => {
    return type === "options"
      ? orderEntryType === "bid"
        ? userCMEDEntitlements?.agressiveOrderIndicator === true &&
          isOrderEntryOpenedFromMain
          ? restingRawPriceOfferOption(orderEntryData)
          : restingRawPriceBidOption(orderEntryData)
        : userCMEDEntitlements?.agressiveOrderIndicator === true &&
            isOrderEntryOpenedFromMain
          ? restingRawPriceBidOption(orderEntryData)
          : restingRawPriceOfferOption(orderEntryData)
      : orderEntryType === "bid"
        ? userCMEDEntitlements?.agressiveOrderIndicator === true &&
          isOrderEntryOpenedFromMain
          ? restingRawPriceOfferOthers(orderEntryData)
          : restingRawPriceBidOthers(orderEntryData)
        : userCMEDEntitlements?.agressiveOrderIndicator === true &&
            isOrderEntryOpenedFromMain
          ? restingRawPriceBidOthers(orderEntryData)
          : restingRawPriceOfferOthers(orderEntryData);
  };

  ///////////////////***********End**************//////////////////////////////

  const [isDefaultAccountSaved, setIsDefaultAccountSaved] =
    useState<boolean>(false);
  const [isDefaultAccountDeleted, setIsDefaultAccountDeleted] =
    useState<boolean>(false);
  const { userPreferences, setUserPreferences } =
    useContext(UserPrefencesContext);
  const [side, setSide] = useState<any>(orderEntryType);
  const [ticks, setTicks] = useState<any>({ up: [], down: [] });
  const [StopTicks, setStopTicks] = useState<any>({ up: [], down: [] });
  const [accounts, setAccounts] = useState<any>({
    data: [],
    isLoading: true,
    error: false,
  });
  const [orderType, setOrderType] = useState<any>({
    data: [],
    isLoading: true,
    error: false,
  });
  const [tifs, setTifs] = useState<any>({
    data: [],
    isLoading: true,
    error: false,
  });
  const [selectedOrderType, setselectedOrderType] = useState<any>();
  const [selectedTif, setselectedTif] = useState<any>();
  const [selectedAccount, setselectedAccount] = useState<any>(undefined);
  const [priceValue, setpriceValue] = useState<string>(
    basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [priceValueRaw, setpriceValueRaw] = useState(
    rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [isIceberg, setisIceberg] = useState(false);
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [errorMsg, seterrorMsg] = useState<string>("");
  const [tickStrategy, settickStrategy] = useState(undefined);
  const [tickGroup, settickGroup] = useState<string | undefined>(undefined);
  const stopPriceRequestIds = useRef<any[]>([]);
  const priceRequestIds = useRef<any[]>([]);
  const [tickCounter, settickCounter] = useState(-1);
  const [stopTickCounter, setStoptickCounter] = useState(-1);
  const [basePriceValue, setbasePriceValue] = useState(
    basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [basePriceValueRaw, setbasePriceValueRaw] = useState(
    rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [quantity, setquantity] = useState(QUANTITY_LIMITS.MIN);
  const [disclosedQuantity, setDisclosedQuantity] = useState(
    QUANTITY_LIMITS.MIN,
  );
  const [stopPrice, setStopPrice] = useState<string>(
    basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [stopPriceRaw, setStopPriceRaw] = useState(
    rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [baseStopPriceValueRaw, setbaseStopPriceValueRaw] = useState(
    rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [baseStopPriceValue, setbaseStopPriceValue] = useState(
    basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
  );
  const [stopPriceErrorMsg, setstopPriceErrorMsg] = useState<string>();
  const [stopPriceErrorMsgFlag, setstopPriceErrorMsgFlag] =
    useState<boolean>(false);
  const [priceMinMaxErrorFlag, setPriceMinMaxErrorFlag] =
    useState<boolean>(false);
  const [stopPriceMinMaxErrorFlag, setStopPriceMinMaxErrorFlag] =
    useState<boolean>(false);

  const [stopPriceValidationErrorMsg, setstopPriceValidationErrorMsg] =
    useState<string>();
  const [stopPriceValidationErrorMsgFlag, setstopValidationPriceErrorMsgFlag] =
    useState<boolean>(false);
  const [accountErrorMessage, setAccountErrorMessage] = useState<string>("");
  const [isOrderConfirmationAlertOpen, setIsOrderConfirmationAlertOpen] =
    useState<boolean>(false);
  const [expiryDate, setexpiryDate] = useState<any>();
  const [priceValueLoadingErrorState, setPriceValueLoadingErrorState] =
    useState<any>({
      isLoading: true,
      error: false,
    });
  const [notes, setNotes] = useState<string>("");
  const [notesErrorFlag, setNotesErrorFlag] = useState<boolean>(false);
  const [contractName, setContractName] = useState<string>("");
  const [contractLoading, setContractLoading] = useState<boolean>(true);
  const [quantityErrorFlag, setQuantityErrorFlag] = useState<boolean>(false);
  const [quantityErrorMsg, setQuantityErrorMsg] = useState<string>("");
  const [disclosedQuantityErrorFlag, setDisclosedQuantityErrorFlag] =
    useState<boolean>(false);
  const [disclosedQuantityErrorMsg, setDisclosedQuantityErrorMsg] =
    useState<string>("");
  const selectedOrderTypeRef = useRef<HTMLIonSelectElement>(null);

  const validateDisclosedQuantity = (disclosedQty: number, mainQty: number) => {
    if (disclosedQty > mainQty && disclosedQty > QUANTITY_LIMITS.MAX) {
      setDisclosedQuantityErrorFlag(true);
      setDisclosedQuantityErrorMsg(
        QuantityErrorConstants.INVALID_DISPLAY_QUANTITY_ERROR,
      );
    } else if (
      disclosedQty < QUANTITY_LIMITS.MIN ||
      disclosedQty > QUANTITY_LIMITS.MAX
    ) {
      setDisclosedQuantityErrorFlag(true);
      setDisclosedQuantityErrorMsg(
        QuantityErrorConstants.ZERO_DISPLAY_QUANTITY_ERROR,
      );
    } else if (disclosedQty > mainQty) {
      setDisclosedQuantityErrorFlag(true);
      setDisclosedQuantityErrorMsg(
        QuantityErrorConstants.INVALID_DISPLAY_QUANTITY_ERROR,
      );
    } else {
      setDisclosedQuantityErrorFlag(false);
      setDisclosedQuantityErrorMsg("");
    }
  };
  const selectedTIFRef = useRef<HTMLIonSelectElement>(null);
  const selectedAccountRef = useRef<HTMLIonSelectElement>(null);
  const dateTimeButtonRef = useRef<HTMLIonDatetimeButtonElement>(null);
  const today = new Date(new Date().toDateString());
  const tableHeaders = ["QTY", "BID", "OFFER", "QTY"];

  const allFutureDates = new Date(
    new Date().getFullYear() + 99,
    new Date().getMonth(),
    new Date().getDate(),
  );

  useEffect(() => {
    !stopPriceErrorMsgFlag && _stopPriceValidation(stopPriceRaw, priceValueRaw);
  }, [priceValue, stopPrice, selectedOrderType]);

  useEffect(() => {
    if (selectedOrderType === "16" && !stopPriceErrorMsgFlag) {
      if (side === "bid" && stopPriceRaw > priceValueRaw) {
        setstopValidationPriceErrorMsgFlag(true);
        setstopPriceValidationErrorMsg(
          "Bid price cannot be lower than stop price",
        );
      } else if (side === "offer" && priceValueRaw > stopPriceRaw) {
        setstopPriceValidationErrorMsg(
          "Offer price cannot be higher than stop price",
        );
        setstopValidationPriceErrorMsgFlag(true);
      } else {
        setstopPriceValidationErrorMsg("");
        setstopValidationPriceErrorMsgFlag(false);
      }
    }
  }, [side]);

  useEffect(() => {
    if (orderEntryType) setSide(orderEntryType);
  }, [orderEntryType]);

  useEffect(() => {
    if (openOrderEntryModal) setSide(orderEntryType);
    else setSide("");
  }, [openOrderEntryModal]);

  useEffect(() => {
    setpriceValue(
      basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setpriceValueRaw(
      rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setbasePriceValue(
      basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setbasePriceValueRaw(
      rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setStopPrice(
      basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setbaseStopPriceValue(
      basicPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setStopPriceRaw(
      rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
    setbaseStopPriceValueRaw(
      rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
    );
  }, [openOrderEntryModal]);

  function _stopPriceValidation(stopPriceRaw: any, orderPriceRaw: any) {
    if (selectedOrderType === "16") {
      if (side === "bid" && stopPriceRaw > orderPriceRaw) {
        setstopValidationPriceErrorMsgFlag(true);
        setstopPriceValidationErrorMsg(
          "Bid price cannot be lower than stop price",
        );
      } else if (side === "offer" && orderPriceRaw > stopPriceRaw) {
        setstopPriceValidationErrorMsg(
          "Offer price cannot be higher than stop price",
        );
        setstopValidationPriceErrorMsgFlag(true);
      } else if (!stopPriceErrorMsgFlag) {
        setstopPriceValidationErrorMsg("");
        setstopValidationPriceErrorMsgFlag(false);
      }
    } else {
      setstopValidationPriceErrorMsgFlag(false);
      setstopPriceValidationErrorMsg("");
    }
  }

  const updateStopPriceDisplayAndFetchTicks = (
    stopPrice: string,
    stopPriceRaw: number,
    baseStopPriceValue: string | number,
    baseStopPriceValueRaw: number,
    isError: boolean,
    errorMessage: string | undefined,
    fetchTickFlag: boolean = true,
  ) => {
    const requestId = uuidv4();
    stopPriceRequestIds.current = [...stopPriceRequestIds.current, requestId];
    setStopPrice(stopPrice);
    setStopPriceRaw(stopPriceRaw);
    setbaseStopPriceValue(baseStopPriceValue);
    setbaseStopPriceValueRaw(baseStopPriceValueRaw);
    setstopPriceErrorMsgFlag(isError);
    setstopPriceErrorMsg(errorMessage);
    fetchTickFlag &&
      fetchPriceTicks({
        basePrice: baseStopPriceValueRaw,
        direction: ["up", "down"],
        requestId: requestId,
      });
    setStoptickCounter(-1); // Common reset for tick counter
  };

  /**
   * Concatenates the new direction ticks to the current direction list
   *
   * @param  {Object} response Updated list of UP or DOWN tick prices
   * @return {undefined}
   */
  function updateTicks(response: any) {
    const pricesResponse = response.payload;
    if (pricesResponse.up !== undefined && pricesResponse.down !== undefined) {
      setTicks(pricesResponse);
    } else if (
      pricesResponse.up !== undefined ||
      pricesResponse.down !== undefined
    ) {
      pricesResponse.up !== undefined
        ? updateUporDownTick("up", pricesResponse.up)
        : updateUporDownTick("down", pricesResponse.down);
    }
  }

  function updateStopTicks(response: any) {
    const pricesResponse = response.payload;
    if (pricesResponse.up !== undefined && pricesResponse.down !== undefined) {
      setStopTicks(pricesResponse);
    } else if (
      pricesResponse.up !== undefined ||
      pricesResponse.down !== undefined
    ) {
      pricesResponse.up !== undefined
        ? updateStopUporDownTick("up", pricesResponse.up)
        : updateStopUporDownTick("down", pricesResponse.down);
    }
  }

  const updateTif = (tif: any) => {
    setselectedTif(tif);
  };

  const updateUporDownTick = (arrayType: any, newValues: any) => {
    setTicks((prevState: any) =>
      removeDuplicatesFromTheFetchingTicks(prevState, newValues, arrayType),
    );
  };

  const updateStopUporDownTick = (arrayType: any, newValues: any) => {
    setStopTicks((prevState: any) =>
      removeDuplicatesFromTheStopFetchingTicks(prevState, newValues, arrayType),
    );
  };
  const ticksIncrementorDecrement = (arr: any) => {
    const checkingKeysInObject = new Set();
    return arr?.filter((item: any) => {
      const key = item?.r;
      if (!checkingKeysInObject.has(key)) {
        checkingKeysInObject.add(key);
        return true;
      }
      return false;
    });
  };

  const stopTicksIncrementorDecrement = (arr: any) => {
    const checkingKeysInObject = new Set();
    const data = arr?.filter((item: any) => {
      const key = item?.r;
      if (!checkingKeysInObject.has(key)) {
        checkingKeysInObject.add(key);
        return true;
      }
      return false;
    });
    return data;
  };

  const removeDuplicatesFromTheStopFetchingTicks = (
    arr: any,
    newValues: any,
    arrayType: any,
  ) => {
    return {
      ...arr,
      [arrayType]: stopTicksIncrementorDecrement([
        ...arr[arrayType],
        ...newValues,
      ]),
    };
  };

  const removeDuplicatesFromTheFetchingTicks = (
    arr: any,
    newValues: any,
    arrayType: any,
  ) => {
    return {
      ...arr,
      [arrayType]: ticksIncrementorDecrement([...arr[arrayType], ...newValues]),
    };
  };

  useEffect(() => {
    if (openOrderEntryModal) {
      PubSub.subscribe(
        pubsubEvents.socketKeys.CMED_ORDER_ENTRY_RESPONSE,
        (msg, data) => {
          let accountData = data.payload.accounts;
          accountData?.sort((a: any, b: any) => {
            const descA = a?.desc;
            const descB = b?.desc;

            // Handle null or undefined values
            if (descA === null || descA === undefined)
              return descB === null || descB === undefined ? 0 : 1;
            if (descB === null || descB === undefined) return -1;

            // Compare as numbers if possible, otherwise compare as strings
            if (typeof descA === "number" && typeof descB === "number") {
              return descA - descB;
            } else {
              return descA.localeCompare(descB);
            }
          });
          setAccounts({
            data: accountData,
            isLoading: false,
            error: false,
          });
          setOrderType({
            data: data.payload.orderTypes,
            isLoading: false,
            error: false,
          });
          setTifs({ data: data.payload.tifs, isLoading: false, error: false });
          setselectedOrderType(data.payload.orderTypes[0]?.id);
          updateTif(data.payload.tifs[0]?.id);
        },
      );

      PubSub.subscribe(
        pubsubEvents.socketKeys.CMED_ALL_CONTRACTS_SUCCESS,
        (msg, data) => {
          setpriceType(data.payload.FractionalPriceType);
          settickStrategy(data.payload.TickStrategy);
          settickGroup(data.payload.TickGroup);
          setContractName(data.payload.Name);
          setContractLoading(false);
        },
      );

      PubSub.subscribe(
        pubsubEvents.socketKeys.CMED_NEW_ORDER_SUCCESS,
        (data) => {
          setOpenOrderEntryModal(false);
        },
      );

      PubSub.subscribe(
        pubsubEvents.socketKeys.CMED_PRICE_TICKS_RESPONSE,
        (msg, data) => {
          if (
            stopPriceRequestIds.current.length > 0 &&
            stopPriceRequestIds.current.find(
              (element) => element === data?.requestID,
            )
          ) {
            updateStopTicks(data);
          } else if (
            priceRequestIds.current.length > 0 &&
            priceRequestIds.current.find(
              (element) => element === data?.requestID,
            )
          ) {
            updateTicks(data);
          } else {
            updateStopTicks(data);
            updateTicks(data);
          }
        },
      );
      orderEntryData && _getTradeableitemInfo();
      orderEntryData && fetchOrderEntryCriteria();
    }
  }, [orderEntryType, orderEntryData, openOrderEntryModal]);

  useEffect(() => {
    if (openOrderEntryModal) {
      orderEntryData &&
        priceType &&
        tickStrategy &&
        _updateGenericPriceInput(
          {
            target: {
              value:
                type === "options"
                  ? side === "bid"
                    ? userCMEDEntitlements?.agressiveOrderIndicator === true &&
                      isOrderEntryOpenedFromMain
                      ? restingPriceOfferOption(orderEntryData)
                      : restingPriceBidOption(orderEntryData)
                    : userCMEDEntitlements?.agressiveOrderIndicator === true &&
                        isOrderEntryOpenedFromMain
                      ? restingPriceBidOption(orderEntryData)
                      : restingPriceOfferOption(orderEntryData)
                  : side === "bid"
                    ? userCMEDEntitlements?.agressiveOrderIndicator === true &&
                      isOrderEntryOpenedFromMain
                      ? restingPriceOfferOthers(orderEntryData)
                      : restingPriceBidOthers(orderEntryData)
                    : userCMEDEntitlements?.agressiveOrderIndicator === true &&
                        isOrderEntryOpenedFromMain
                      ? restingPriceBidOthers(orderEntryData)
                      : restingPriceOfferOthers(orderEntryData),
            },
          },
          "price",
          true,
        );
      setStopPriceRaw(
        rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
      );
      setbaseStopPriceValueRaw(
        rawPrice(orderEntryType, orderEntryData, type, userCMEDEntitlements),
      );
    }
  }, [priceType, tickStrategy, openOrderEntryModal]);

  function idExists(
    accounts: { id: string; desc: string }[],
    idToCheck: string,
  ): boolean {
    return accounts?.some((account) => account.id === idToCheck);
  }

  useEffect(() => {
    if (openOrderEntryModal) {
      if (userPreferences.defaultaccount.replace(/"/g, "")?.length > 0) {
        if (!accounts?.isLoading) {
          const exists = idExists(
            accounts?.data,
            userPreferences.defaultaccount.replace(/"/g, ""),
          );
          if (!exists) {
            const updatedPreferences: UserPreferences = {
              ...userPreferences,
              defaultaccount: "",
            };
            setUserPreferences(updatedPreferences);
            saveUserPreferences(updatedPreferences);
            setselectedAccount(undefined);
          } else {
            setselectedAccount(
              userPreferences.defaultaccount.replace(/"/g, ""),
            );
          }
        }
      } else {
        setselectedAccount(undefined);
      }
    }
  }, [accounts, openOrderEntryModal, userPreferences]);

  function _updateQuantity(obj: any) {
    let updatedQuantity;
    if (obj.dir === "up") {
      updatedQuantity = quantity + obj.number;
    } else if (quantity > 0) {
      updatedQuantity = quantity - obj.number;
    }
    if (typeof updatedQuantity !== "undefined") {
      setquantity(updatedQuantity);
      if (
        updatedQuantity < QUANTITY_LIMITS.MIN ||
        updatedQuantity > QUANTITY_LIMITS.MAX
      ) {
        setQuantityErrorFlag(true);
        setQuantityErrorMsg(QuantityErrorConstants.ZERO_QUANTITY_ERROR);
      } else {
        setQuantityErrorFlag(false);
        setQuantityErrorMsg("");
      }
      if (isIceberg)
        validateDisclosedQuantity(disclosedQuantity, updatedQuantity);
    }
  }

  function _updateDisclosedQuantity(obj: any) {
    let updatedQuantity;
    if (obj.dir === "up") {
      updatedQuantity = disclosedQuantity + obj.number;
    } else if (disclosedQuantity > 0) {
      updatedQuantity = disclosedQuantity - obj.number;
    }
    if (typeof updatedQuantity !== "undefined") {
      setDisclosedQuantity(updatedQuantity);
      validateDisclosedQuantity(updatedQuantity, quantity);
    }
  }

  function _getTradeableitemInfo() {
    const TradeableItemId =
      type === "options" ? orderEntryData?.i : orderEntryData?.ii;
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_GET_CONTRACTS_BY_ITEM_ID,
      requestID: uuidv4(),
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {
        TradeableItemId,
      },
    });
  }

  const initiallyUpdatingStopPrice = (
    price: any,
    basePrice: any,
    priceRaw: any,
    basePriceRaw: any,
  ) => {
    if (selectedOrderType !== "8" && selectedOrderType !== "16") {
      setStopPriceRaw(priceRaw);
      setbaseStopPriceValueRaw(basePriceRaw);
      setStopPrice(price);
      setbaseStopPriceValue(basePrice);
    }
    _stopPriceValidation(stopPriceRaw, priceRaw);
  };

  const updatePriceDisplayAndFetchTicks = (
    price: string,
    priceRaw: number,
    basePrice: string | number,
    basePriceRaw: number,
    isError: boolean,
    errorMessage: string = "",
  ) => {
    const requestId = uuidv4();
    priceRequestIds.current = [...priceRequestIds.current, requestId];
    setpriceValue(price);
    setpriceValueRaw(priceRaw);
    setbasePriceValue(basePrice);
    setbasePriceValueRaw(basePriceRaw);
    setErrorFlag(isError);
    seterrorMsg(errorMessage);
    // This state always sets error: false, which might be intentional - to re-use decouple this
    // or could be reviewed
    setPriceValueLoadingErrorState({ isLoading: false, error: false });
    fetchPriceTicks({
      basePrice: basePriceRaw,
      direction: ["up", "down"],
      requestId: requestId,
    });
    settickCounter(-1); // Common reset for tick counter
  };

  const count = (n: string | number): number => {
    if (Number.isInteger(n)) {
      return 0;
    }
    let numStr = String(n);
    // Check for scientific notation (e.g., "5e-7", "1.23e-4")
    const lowerNumStr = numStr.toLowerCase();
    if (lowerNumStr.includes("e-")) {
      const parts = lowerNumStr.split("e-");
      const coefficient = parts[0];
      const exponent = parseInt(parts[1], 10);

      let decimalPlaces = exponent;
      if (coefficient.includes(".")) {
        const coefficientDecimalPart = coefficient.split(".")[1];
        decimalPlaces += coefficientDecimalPart.length;
      }
      return decimalPlaces;
    }

    if (numStr.includes(".")) {
      return numStr.split(".")[1].length;
    }
    return 0;
  };
  const getNearestValidPrice = (price: string, tickStrategy: any) => {
    const sanitizedPrice = parseFloat(price.replace(/'/g, "."));
    const strategy = parseFloat(tickStrategy);
    const quotent = tickStrategy && sanitizedPrice / strategy;
    const roundedQuotient = quotent && Math.round(quotent);
    return (
      tickStrategy &&
      roundedQuotient &&
      (roundedQuotient * strategy).toFixed(count(strategy))
    );
  };

  function onKeyUpPressHandler(e: any, priceUpdateType: "price" | "stopPrice") {
    const isStopPrice = priceUpdateType === "stopPrice";
    const isCabinetString = /^C\d+$/i.test(priceValue);

    if (e.key === "Backspace" && isCabinetString) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            "",
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            "",
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          );
      e.preventDefault();
    }
  }

  function _updateGenericPriceInput(
    event: any,
    priceUpdateType: "price" | "stopPrice",
    firstLoad?: boolean,
  ) {
    const isStopPrice = priceUpdateType === "stopPrice";
    const inputValue =
      event?.target?.value.toString().replaceAll(",", "") || "";
    const currentPriceString =
      priceType !== "NotFractional"
        ? inputValue?.replace(/\./g, "'")
        : inputValue;
    if (!tickGroup || tickGroup === "") return;
    const { decimal_number: decimalPrice, valid: isFractionalFormatValid } =
      FractionalToDecimalConverter(currentPriceString, priceType);
    isStopPrice
      ? setStopPriceMinMaxErrorFlag(false)
      : setPriceMinMaxErrorFlag(false);
    const tickGroupInfo = parseTickGroupString(decimalPrice, tickGroup);
    const min = tickGroupInfo.minimumValue
      ? tickGroupInfo.minimumValue
      : -1000000;
    const max = tickGroupInfo.maximumValue
      ? tickGroupInfo.maximumValue
      : 1000000;
    const isPriceAdheringToTickSize = validatePrice(
      decimalPrice,
      tickGroupInfo.tickSize,
      priceType,
    );
    const isZeroAllowed = min < 0 && 0 < max;
    if (isStopPrice) {
      setstopPriceErrorMsgFlag(false);
      setstopPriceErrorMsg(undefined);
    } else {
      setErrorFlag(false);
      seterrorMsg("");
      setPriceValueLoadingErrorState({ isLoading: false, error: false });
    }
    const isCabinetString = /^C\d+$/i.test(priceValue);
    const isEffectivelyZero =
      currentPriceString?.toString().replace(/[.'-]/g, "") == 0;
    const isEmptyOrWhitespace =
      [undefined, null, ""].includes(currentPriceString) ||
      currentPriceString.trim() === "";
    const isOnlyDelimiter =
      currentPriceString === "'" ||
      currentPriceString === "." ||
      currentPriceString === "-";
    if (isEmptyOrWhitespace) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          );
      if (isStopPrice) {
        setstopPriceValidationErrorMsg("");
        setstopValidationPriceErrorMsgFlag(false);
      }
    } else if (isCabinetString) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            priceValue,
            priceValueRaw,
            priceValue,
            priceValueRaw,
            false,
            "",
          )
        : updatePriceDisplayAndFetchTicks(
            priceValue,
            priceValueRaw,
            priceValue,
            priceValueRaw,
            false,
            "",
          );
    } else if (isOnlyDelimiter) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          );
    } else if (isEffectivelyZero) {
      let outOfRangeMsg;
      if (!isZeroAllowed) {
        outOfRangeMsg = tickGroupInfo.cabinetError
          ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
          : PriceErrorConstants.ZERO_PRICE_ERROR;
        isStopPrice
          ? updateStopPriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              true,
              outOfRangeMsg,
            )
          : updatePriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              true,
              outOfRangeMsg,
            );
      } else {
        isStopPrice
          ? updateStopPriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              false,
              "",
            )
          : updatePriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              false,
              "",
            );
      }
      if (!isStopPrice) initiallyUpdatingStopPrice(currentPriceString, 0, 0, 0);
    } else if (firstLoad) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            basicPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            rawPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            basicPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            rawPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            false,
            "",
          )
        : updatePriceDisplayAndFetchTicks(
            basicPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            rawPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            basicPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            rawPrice(
              orderEntryType,
              orderEntryData,
              type,
              userCMEDEntitlements,
            ),
            false,
            "",
          );
    } else if (decimalPrice > max || decimalPrice < min) {
      const outOfRangeMsg = tickGroupInfo.cabinetError
        ? PriceErrorConstants.TICK_UP_TO_CABINET_PRICES_ERROR
        : `Price has to be between ${min.toString().includes("e") ? min.toFixed(Number(min.toString().split("-")[1])) : DecimalToFractionalConverter(min, priceType)} and ${max}.`;
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            outOfRangeMsg,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            outOfRangeMsg,
          );
      isStopPrice
        ? setStopPriceMinMaxErrorFlag(true)
        : setPriceMinMaxErrorFlag(true);
      if (!isStopPrice) initiallyUpdatingStopPrice(currentPriceString, 0, 0, 0);
    } else if (tickGroupInfo.tickSize === null) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          );
      if (!isStopPrice) initiallyUpdatingStopPrice(currentPriceString, 0, 0, 0);
    } else if (!isPriceAdheringToTickSize || !isFractionalFormatValid) {
      let finalValRaw = parseFloat(
        getNearestValidPrice(decimalPrice.toString(), tickGroupInfo.tickSize),
      );
      finalValRaw === 0 ? (finalValRaw = 0) : (finalValRaw = finalValRaw); // this is to handle -0, which is a valid Number is js
      const errorMessage =
        priceType === "NotFractional"
          ? PriceErrorConstants.TICK_SIZE + tickStrategy
          : "Price has to be of Type: " + priceType;
      const finalValueFractional =
        priceType !== "NotFractional"
          ? DecimalToFractionalConverter(finalValRaw, priceType)
          : finalValRaw.toFixed(count(tickGroupInfo.tickSize));
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            finalValRaw,
            finalValueFractional,
            finalValRaw,
            true,
            errorMessage,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            finalValRaw,
            finalValueFractional,
            finalValRaw,
            true,
            errorMessage,
          );
      if (!isStopPrice)
        initiallyUpdatingStopPrice(
          currentPriceString,
          decimalPrice,
          decimalPrice,
          decimalPrice,
        );
      if (isStopPrice) {
        setstopPriceValidationErrorMsg("");
        setstopValidationPriceErrorMsgFlag(false);
      }
    } else {
      // Valid price
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            decimalPrice,
            currentPriceString,
            decimalPrice,
            false,
            "",
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            decimalPrice,
            currentPriceString,
            decimalPrice,
            false,
            "",
          );
      if (!isStopPrice)
        initiallyUpdatingStopPrice(
          currentPriceString,
          currentPriceString,
          decimalPrice,
          decimalPrice,
        );
    }
  }

  function _beforePriceInput(e: any) {
    const inputElement = e.target as HTMLInputElement;
    const { selectionStart, selectionEnd, value: currentValue } = inputElement;
    const insertedData =
      priceType !== "NotFractional"
        ? e.data.replace(".", "'") || ""
        : e.data.replace("", "") || ""; // e.data can be null (e.g., for deletion)
    let potentialValueAfterOperation = currentValue;
    if (selectionStart !== null && selectionEnd !== null) {
      potentialValueAfterOperation =
        currentValue.substring(0, selectionStart) +
        insertedData +
        currentValue.substring(selectionEnd);
    }
    // Allow deletion that results in an empty string to proceed; _updatePriceInput will handle empty validation.
    if (potentialValueAfterOperation.trim() === "" && insertedData === "") {
      return;
    }
    const parsedPriceString = potentialValueAfterOperation
      ?.toString()
      .replaceAll(",", "");
    const tickGroupInfo1 = parseTickGroupString(
      parseFloat(parsedPriceString),
      tickGroup,
    );
    let decimalPlaces;
    if (tickGroupInfo1.cabinetIndicator) {
      decimalPlaces = tickGroupInfo1.decimalPlaces;
    } else {
      tickGroupInfo1.tickSize !== null && priceType === "NotFractional"
        ? (decimalPlaces = count(tickGroupInfo1.tickSize.toString()))
        : tickStrategy !== undefined
          ? (decimalPlaces = count(tickStrategy))
          : (decimalPlaces = 0);
    }
    const isInputFormatValidByRegex = PriceRegexValidator(
      potentialValueAfterOperation,
      priceType,
      decimalPlaces,
      componentusedIn,
    );
    if (!isInputFormatValidByRegex) {
      e.preventDefault();
    }
  }

  const isStartDateBlock = (dateString: string) => {
    const date = new Date(dateString).toISOString();
    const endDate = new Date(
      parseInt(allFutureDates.getTime()?.toString()),
    ).toISOString();
    if (date < endDate) return true;
    else return false;
  };

  function fetchPriceTicks(options: any) {
    options?.basePrice !== null &&
      send(config.socket.channels.TRADING, {
        action: config.socket.actions.CMED_ITEM_PRICES,
        requestID: options.requestId,
        type: "cmedGetPriceTicksRequest",
        payload: {
          itemId: type === "options" ? orderEntryData?.i : orderEntryData?.ii, // a valid value taken from ITradingGridGroupItemMarketData.ii
          basePrice: options?.basePrice, // Decimal? or does it need to be fractional sometimes? b.f or bo.f
          direction: options?.direction, // true=Up, false=Down
        },
      });
  }
  function fetchOrderEntryCriteria() {
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_ORDER_CRITERIA,
      requestID: uuidv4(),
      type: "cmedOrderEntryCriteriaRequest",
      payload: {
        basePrice: orderEntryData?.bb?.r,
        itemId: type === "options" ? orderEntryData?.i : orderEntryData?.ii,
      },
    });
  }

  function _tickHandler(
    obj: { dir: "up" | "down" },
    priceContext: "limitOrder" | "stopOrder",
  ) {
    const isStopOrderContext = priceContext === "stopOrder";

    // Determine which set of state variables and setters to use
    const currentPriceValue = isStopOrderContext ? stopPrice : priceValue;
    const setCurrentPriceValue = isStopOrderContext
      ? setStopPrice
      : setpriceValue;
    const currentPriceValueRaw = isStopOrderContext
      ? stopPriceRaw
      : priceValueRaw;
    const setCurrentPriceValueRaw = isStopOrderContext
      ? setStopPriceRaw
      : setpriceValueRaw;
    const currentBasePriceValue = isStopOrderContext
      ? baseStopPriceValue
      : basePriceValue;
    const currentBasePriceValueRaw = isStopOrderContext
      ? baseStopPriceValueRaw
      : basePriceValueRaw;
    const currentTickCounter = isStopOrderContext
      ? stopTickCounter
      : tickCounter;
    const setCurrentTickCounter = isStopOrderContext
      ? setStoptickCounter
      : settickCounter;
    const pricesSource = isStopOrderContext ? StopTicks : ticks;
    const currentPriceRequestIdsRef = isStopOrderContext
      ? stopPriceRequestIds
      : priceRequestIds;
    const minMaxErrorFlag = isStopOrderContext
      ? stopPriceMinMaxErrorFlag
      : priceMinMaxErrorFlag;
    const setMinMaxErrorFlag = isStopOrderContext
      ? setStopPriceMinMaxErrorFlag
      : setPriceMinMaxErrorFlag;

    let dirConditional;
    const priceList = pricesSource[obj.dir],
      priceListLength = priceList.length - 1;

    if (
      currentPriceValueRaw !== undefined &&
      currentBasePriceValueRaw !== undefined
    ) {
      dirConditional =
        obj.dir === "up"
          ? currentPriceValueRaw >= currentBasePriceValueRaw
          : currentPriceValueRaw <= currentBasePriceValueRaw;
    } else {
      // Raw price or base raw price is undefined, cannot determine dirConditional
      return;
    }

    const oppositeDir = obj.dir === "up" ? "down" : "up";
    let nextPriceCandidate;
    let newTickCounter;
    if (dirConditional) {
      newTickCounter = currentTickCounter + 1;
      if (
        newTickCounter === priceListLength &&
        priceList[priceListLength]?.r !== undefined
      ) {
        const requestId = uuidv4();
        currentPriceRequestIdsRef.current = [
          ...currentPriceRequestIdsRef.current,
          requestId,
        ];
        fetchPriceTicks({
          basePrice: priceList[priceListLength].r,
          direction: [obj.dir],
          requestId: requestId,
        });
      }
      nextPriceCandidate =
        newTickCounter === -1
          ? "default"
          : pricesSource[obj.dir][newTickCounter];
    } else {
      newTickCounter = currentTickCounter - 1;
      nextPriceCandidate =
        newTickCounter === -1
          ? "default"
          : pricesSource[oppositeDir][newTickCounter];
    }

    const isEffectivelyZeroNPC =
      nextPriceCandidate?.f?.toString().replace(/[.'-]/g, "") == 0;
    const isEffectivelyZeroPriceCandidate =
      currentPriceValue?.toString().replace(/[.'-]/g, "") == "0";
    if (isEffectivelyZeroNPC && isEffectivelyZeroPriceCandidate) {
      return;
    }
    // console.log(FractionalToDecimalConverter(nextPriceCandidate.f.replace(",", ""), priceType).decimal_number , FractionalToDecimalConverter(currentPriceValue.toString().replace(",", ""), priceType).decimal_number ,"boom", nextPriceCandidate.f , currentPriceValue, "bb")
    // If the next potential price is the same as the current price, do nothing.
    if (
      nextPriceCandidate &&
      nextPriceCandidate !== "default" &&
      nextPriceCandidate.f === currentPriceValue
    ) {
      return;
    }
    // Trying to tick to base, but already at base.
    if (
      nextPriceCandidate === "default" &&
      currentPriceValueRaw === currentBasePriceValueRaw
    ) {
      return;
    }

    if (minMaxErrorFlag) {
      if (obj.dir === "down" && componentusedIn === "optionsGrid") {
        setCurrentTickCounter(-1);
      } else {
        setCurrentTickCounter(newTickCounter);
      }
      setMinMaxErrorFlag(false);
    } else {
      setCurrentTickCounter(newTickCounter);
    }

    const finalPriceToSet = nextPriceCandidate;

    if (finalPriceToSet && finalPriceToSet === "default") {
      setCurrentPriceValue(currentBasePriceValue);
      setCurrentPriceValueRaw(currentBasePriceValueRaw);

      const isEffectivelyZero =
        currentBasePriceValueRaw?.toString().replace(/[.'-]/g, "") == 0;
      const tickGroupInfo = parseTickGroupString(
        currentBasePriceValue,
        tickGroup,
      );
      const min = tickGroupInfo.minimumValue
        ? tickGroupInfo.minimumValue
        : -1000000;
      const max = tickGroupInfo.maximumValue
        ? tickGroupInfo.maximumValue
        : 1000000;
      const isZeroAllowed = min < 0 && 0 < max;

      if (isStopOrderContext) {
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setstopPriceErrorMsgFlag(true);
          setstopPriceErrorMsg(outOfRangeMsg);
        } else {
          setstopPriceErrorMsgFlag(false);
          setstopPriceErrorMsg("");
        }
      } else {
        // limitOrder context
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setErrorFlag(true);
          seterrorMsg(outOfRangeMsg);
        } else {
          setErrorFlag(false);
          seterrorMsg("");
          setPriceValueLoadingErrorState({ isLoading: false, error: false });
        }
      }
    } else if (finalPriceToSet) {
      const isEffectivelyZero = finalPriceToSet?.r == 0;
      const tickGroupInfo = parseTickGroupString(finalPriceToSet?.r, tickGroup);
      const min = tickGroupInfo.minimumValue
        ? tickGroupInfo.minimumValue
        : -1000000;
      const max = tickGroupInfo.maximumValue
        ? tickGroupInfo.maximumValue
        : 1000000;
      const isZeroAllowed = min < 0 && 0 < max;

      setCurrentPriceValue(finalPriceToSet?.f);
      setCurrentPriceValueRaw(finalPriceToSet?.r);

      if (isStopOrderContext) {
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setstopPriceErrorMsgFlag(true);
          setstopPriceErrorMsg(outOfRangeMsg);
        } else {
          setstopPriceErrorMsgFlag(false);
          setstopPriceErrorMsg("");
        }
      } else {
        // limitOrder context
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setErrorFlag(true);
          seterrorMsg(outOfRangeMsg);
        } else {
          setErrorFlag(false);
          seterrorMsg("");
          setPriceValueLoadingErrorState({ isLoading: false, error: false });
        }
      }

      // TODO : Boilerplate code for syncing up price and stopprice - enable once all tick work is done
      // if ((selectedOrderType === "8" || selectedOrderType === "16") && errorFlag) {
      //   updateStopPriceDisplayAndFetchTicks(finalPriceToSet?.f, finalPriceToSet?.r, finalPriceToSet?.f, finalPriceToSet?.r, false, "")
      // }
      // if (side == "bid") {
      //   if ((selectedOrderType == 8 || selectedOrderType == 16) && (finalPriceToSet?.r < baseStopPriceValueRaw)) {
      //     updateStopPriceDisplayAndFetchTicks(finalPriceToSet?.f, finalPriceToSet?.r, finalPriceToSet?.f, finalPriceToSet?.r, false, "")
      //   }
      // } else {
      //   if ((selectedOrderType == 8 || selectedOrderType == 16) && (finalPriceToSet?.r > baseStopPriceValueRaw)) {
      //     updateStopPriceDisplayAndFetchTicks(finalPriceToSet?.f, finalPriceToSet?.r, finalPriceToSet?.f, finalPriceToSet?.r, false, "")
      //   }
      // }
    }

    // Specific side effects after price update
    if (!isStopOrderContext) {
      // limitOrder context
      if (selectedOrderType !== "8" && selectedOrderType !== "16") {
        const effectivePriceF =
          finalPriceToSet === "default"
            ? String(currentBasePriceValue)
            : finalPriceToSet?.f;
        const effectivePriceR =
          finalPriceToSet === "default"
            ? Number(currentBasePriceValueRaw)
            : finalPriceToSet?.r;

        if (effectivePriceF !== undefined && effectivePriceR !== undefined) {
          updateStopPriceDisplayAndFetchTicks(
            effectivePriceF,
            effectivePriceR,
            effectivePriceF,
            effectivePriceR,
            false,
            "",
            false,
          );
        }
      }
    }
  }

  function submitOrderRequest() {
    startMetric(MetricConstants.ORDER_ENTRY_LATENCY, MetricTypeConstants.TIMER);
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_ORDER_ENTRY,
      requestID: uuidv4(),
      type: "cmedOrderEntryRequest",
      payload: {
        orderPrice:
          selectedOrderType !== 2 ||
          selectedOrderType !== 4 ||
          selectedOrderType !== 8
            ? priceValueRaw
            : null,
        orderQuantity: quantity,
        side: side === "bid" ? 1 : 2,
        tif: selectedTif,
        orderType: selectedOrderType,
        itemId: type === "options" ? orderEntryData?.i : orderEntryData?.ii,
        accountId: selectedAccount,
        stopPrice:
          selectedOrderType === "8" || selectedOrderType === "16"
            ? stopPriceRaw
            : null,

        expiryDate:
          selectedTif === "4"
            ? !isEmpty(expiryDate)
              ? formatDate(expiryDate, "API")
              : formatDate(today, "API")
            : null,

        disclosedQuantity:
          isIceberg === true && disclosedQuantity !== 0
            ? disclosedQuantity
            : null,
        orderHandling: 1,
        // orderHandling: params.orderHandling ? params.orderHandling.toString() : '1',
        executingPartyIdentifier: "",
        // executingPartyIdentifier: params.executingPartyIdentifier ? params.executingPartyIdentifier.toString() : '',
        ignoreWarnings: "",
        // ignoreWarnings: this.get('ignoreWarnings')
        notes: notes,
      },
    });
    if (side === "bid") {
      switch (componentusedIn) {
        case "optionsGrid":
          CMEDfirebaseLogEvent(
            firebaseEventConfig.CMEDComponentNames.CMED_OPTIONS_GRID,
            firebaseEventConfig.eventNames.CMED_OPTIONS_GRID
              .CMED_OPTIONS_GRID_NEW_BID,
          );
          break;
        case "marketData":
          CMEDfirebaseLogEvent(
            firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
            firebaseEventConfig.eventNames.CMED_MARKET_DATA
              .CMED_MARKET_DATA_NEW_BID,
          );
          break;
        default:
          break;
      }
    } else {
      switch (componentusedIn) {
        case "optionsGrid":
          CMEDfirebaseLogEvent(
            firebaseEventConfig.CMEDComponentNames.CMED_OPTIONS_GRID,
            firebaseEventConfig.eventNames.CMED_OPTIONS_GRID
              .CMED_OPTIONS_GRID_NEW_OFFER,
          );
          break;
        case "marketData":
          CMEDfirebaseLogEvent(
            firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
            firebaseEventConfig.eventNames.CMED_MARKET_DATA
              .CMED_MARKET_DATA_NEW_OFFER,
          );
          break;
        default:
          break;
      }
    }
  }

  function handleOrderEntry() {
    hapticsImpactMedium();
    if (!selectedAccount) {
      setAccountErrorMessage("Please select an account");
    } else if (
      !errorFlag &&
      !notesErrorFlag &&
      !quantityErrorFlag &&
      !disclosedQuantityErrorFlag
    ) {
      if (
        !stopPriceErrorMsgFlag &&
        userCMEDEntitlements?.warnWhenSubmittingOrder
      ) {
        setIsOrderConfirmationAlertOpen(true);
      } else if (
        !stopPriceErrorMsgFlag &&
        !userCMEDEntitlements?.warnWhenSubmittingOrder
      ) {
        submitOrderRequest();
      }
    }
  }
  const _handleKeyDownInput = (event: any) => {
    if (
      event.data &&
      (event.data.includes(".") ||
        event.data.includes(",") ||
        event.data.includes("-"))
    ) {
      event.preventDefault();
    }
  };

  function _updateQuantityInput(event: any) {
    const val = +event.target.value.replace(/[^0-9]/g, "");
    event.target.value = val;
    setquantity(val);
    if (val < QUANTITY_LIMITS.MIN || val > QUANTITY_LIMITS.MAX) {
      setQuantityErrorFlag(true);
      setQuantityErrorMsg(QuantityErrorConstants.ZERO_QUANTITY_ERROR);
    } else {
      setQuantityErrorFlag(false);
      setQuantityErrorMsg("");
    }
    if (isIceberg) validateDisclosedQuantity(disclosedQuantity, val);
  }

  function _updateDisclosedQuantityInput(event: any) {
    const disclosedQuantity = +event.target.value.replace(/[^0-9]/g, "");
    event.target.value = disclosedQuantity;
    setDisclosedQuantity(disclosedQuantity);
    validateDisclosedQuantity(disclosedQuantity, quantity);
  }

  function _handleDateChange(date: any) {
    setexpiryDate(date);
  }

  /**
   * Formats date for UI or API
   * accepts.
   * @param  {string} date selected date
   * @param  {string} date format format
   * @return {string}      converted date
   */
  function formatDate(date: any, format: any) {
    let chosenFormat = "API";
    if (format === "UI") {
      chosenFormat = config.dateFormats.dateFormatUI;
    } else if (format === "API") {
      chosenFormat = config.dateFormats.dateFormatAPI;
    } else if (format === "SHORT") {
      chosenFormat = config.dateFormats.dateFormatShort;
    } else if (format === "ISODATE") {
      chosenFormat = config.dateFormats.isoDateFormat;
    }
    return moment(date).format(chosenFormat);
  }

  const onChangeOrderType = (e: any) => {
    if (
      selectedOrderType === "1" &&
      (e.detail.value === "8" || e.detail.value === "16")
    ) {
      _updateGenericPriceInput(
        {
          target: {
            value: priceValue,
          },
        },
        "stopPrice",
      );
    } else if (e.detail.value === "8" || e.detail.value === "16") {
      _updateGenericPriceInput(
        {
          target: {
            value: stopPrice,
          },
        },
        "stopPrice",
      );
      // updateStopPriceDisplayAndFetchTicks(stopPrice, stopPriceRaw, stopPrice, stopPriceRaw, stopPriceErrorMsgFlag, stopPriceErrorMsg)
    }
    setselectedOrderType(e.detail.value);
  };

  const handleSaveDefaultAccount = (e: any) => {
    if (e.detail.checked) {
      const updatedPreferences: UserPreferences = {
        ...userPreferences,
        defaultaccount: selectedAccount,
      };
      setUserPreferences(updatedPreferences);
      saveUserPreferences(updatedPreferences);
      setIsDefaultAccountSaved(true);
    } else {
      const updatedPreferences: UserPreferences = {
        ...userPreferences,
        defaultaccount: "",
      };
      setUserPreferences(updatedPreferences);
      saveUserPreferences(updatedPreferences);
      setIsDefaultAccountDeleted(true);
    }
  };

  function _updateNotesInput(event: any) {
    setNotes(event?.target?.value);
    if (event?.target?.value?.length > 50) {
      setNotesErrorFlag(true);
    } else {
      setNotesErrorFlag(false);
    }
  }

  const orderConfirmationPopup = () => {
    if (selectedOrderType === "8") {
      return (
        `${side?.toLocaleUpperCase() === "BID" ? "Buy" : "Sell"} ${
          componentusedIn === "marketData"
            ? orderEntryData?.c
            : selectedOption?.TermStructureDescription
        }` +
        `${
          componentusedIn === "marketData" ? "" : ` ${orderEntryData?.s?.f}`
        }` +
        ", " +
        `${quantity}` +
        " @ Stop:" +
        `${stopPrice}`
      );
    } else if (selectedOrderType === "16") {
      return (
        `${side?.toLocaleUpperCase() === "BID" ? "Buy" : "Sell"} ${
          componentusedIn === "marketData"
            ? orderEntryData?.c
            : selectedOption?.TermStructureDescription
        }` +
        `${
          componentusedIn === "marketData" ? "" : ` ${orderEntryData?.s?.f}`
        }` +
        ", " +
        `${quantity}` +
        " @ Stop:" +
        `${stopPrice}` +
        " " +
        "(Limit:" +
        " " +
        `${priceValue}` +
        ")"
      );
    } else {
      return (
        `${side?.toLocaleUpperCase() === "BID" ? "Buy" : "Sell"} ${
          componentusedIn === "marketData"
            ? orderEntryData?.c
            : selectedOption?.TermStructureDescription
        }` +
        `${
          componentusedIn === "marketData" ? "" : ` ${orderEntryData?.s?.f}`
        }` +
        ", " +
        `${quantity}` +
        " @ " +
        `${priceValue}` +
        ", " +
        `${
          orderType?.data?.find((obj: any) => obj?.id === selectedOrderType)
            ?.desc
        }`
      );
    }
  };

  const handleOpenOrderType = () => {
    if (selectedOrderTypeRef?.current) {
      selectedOrderTypeRef?.current?.open();
      hapticsImpactMedium();
    }
  };

  const handleOpenTIF = () => {
    if (selectedTIFRef?.current) {
      selectedTIFRef?.current?.open();
      hapticsImpactMedium();
    }
  };

  const handleOpenAccount = () => {
    if (selectedAccountRef?.current) {
      selectedAccountRef?.current?.open();
      hapticsImpactMedium();
    }
  };

  return (
    <React.Fragment>
      <IonModal
        isOpen={openOrderEntryModal}
        onDidDismiss={() => {
          settickCounter(-1);
          setStoptickCounter(-1);
          updateTif(tifs?.[0]?.id);
          setselectedAccount(
            userPreferences.defaultaccount.replace(/"/g, "")?.length > 0
              ? userPreferences.defaultaccount.replace(/"/g, "")
              : undefined,
          );
          setAccountErrorMessage("");
          setOpenOrderEntryModal(false);
          setquantity(QUANTITY_LIMITS.MIN);
          setselectedOrderType(orderType?.[0]?.id);
          settickStrategy(undefined);
          setpriceType(undefined);
          setpriceValue("");
          setpriceValueRaw(undefined);
          setbasePriceValue(undefined);
          setbaseStopPriceValue(undefined);
          setbasePriceValueRaw(undefined);
          setbaseStopPriceValueRaw(undefined);
          setstopPriceErrorMsg("");
          setstopPriceErrorMsgFlag(false);
          setStopPrice("");
          setStopPriceRaw(undefined);
          setErrorFlag(false);
          setisIceberg(false);
          setDisclosedQuantity(1);
          setErrorFlag(false);
          seterrorMsg("");
          setAccounts({
            data: [],
            isLoading: true,
            error: false,
          });
          setTifs({
            data: [],
            isLoading: true,
            error: false,
          });
          setOrderType({
            data: [],
            isLoading: true,
            error: false,
          });
          setPriceValueLoadingErrorState({
            isLoading: true,
            error: false,
          });
          setNotes("");
          setNotesErrorFlag(false);
          setContractName("");
          setContractLoading(true);
          setexpiryDate(new Date().toISOString());
          setIsOrderEntryOpenedFromMain(undefined);
          setQuantityErrorFlag(false);
          setQuantityErrorMsg("");
          setDisclosedQuantityErrorFlag(false);
          setDisclosedQuantityErrorMsg("");
        }}
      >
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle>
              <p className="ion-no-margin text-bold">ORDER DETAILS</p>
            </IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => {
                  settickCounter(-1);
                  updateTif(tifs?.[0]?.id);
                  setselectedAccount(
                    userPreferences.defaultaccount.replace(/"/g, "")?.length > 0
                      ? userPreferences.defaultaccount.replace(/"/g, "")
                      : undefined,
                  );
                  setAccountErrorMessage("");
                  setOpenOrderEntryModal(false);
                  setquantity(QUANTITY_LIMITS.MIN);
                  setselectedOrderType(orderType?.[0]?.id);
                  settickStrategy(undefined);
                  setpriceType(undefined);
                  setpriceValue("");
                  setpriceValueRaw(undefined);
                  setbasePriceValue(undefined);
                  setbaseStopPriceValue(undefined);
                  setbasePriceValueRaw(undefined);
                  setbaseStopPriceValueRaw(undefined);
                  setstopPriceErrorMsg("");
                  setstopPriceErrorMsgFlag(false);
                  setStopPrice("");
                  setStopPriceRaw(undefined);
                  setErrorFlag(false);
                  setisIceberg(false);
                  setDisclosedQuantity(1);
                  setErrorFlag(false);
                  seterrorMsg("");
                  setAccounts({
                    data: [],
                    isLoading: true,
                    error: false,
                  });
                  setTifs({
                    data: [],
                    isLoading: true,
                    error: false,
                  });
                  setOrderType({
                    data: [],
                    isLoading: true,
                    error: false,
                  });
                  setPriceValueLoadingErrorState({
                    isLoading: true,
                    error: false,
                  });
                  setNotes("");
                  setNotesErrorFlag(false);
                  setContractName("");
                  setContractLoading(true);
                  setexpiryDate(new Date().toISOString());
                  setIsOrderEntryOpenedFromMain(undefined);
                  setQuantityErrorFlag(false);
                  setQuantityErrorMsg("");
                  setDisclosedQuantityErrorFlag(false);
                  setDisclosedQuantityErrorMsg("");
                  hapticsImpactMedium();
                }}
              >
                <IonIcon
                  icon={closeOutline}
                  color="dark"
                  slot="icon-only"
                ></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        {priceValueLoadingErrorState?.isLoading ||
        orderType?.isLoading ||
        tifs?.isLoading ||
        accounts?.isLoading ||
        contractLoading ? (
          <Skeleton__OrderEntryModal />
        ) : (
          <Fragment>
            <IonContent>
              <div
                style={{
                  marginLeft: "13px",
                  marginRight: "13px",
                  marginTop: "18px",
                  marginBottom: "10px",
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    wordBreak: "break-all",
                  }}
                >
                  <p
                    className="ion-no-margin text-bold"
                    style={{
                      fontSize: "var(--one-font-size-16)",
                    }}
                  >
                    {componentusedIn === "marketData"
                      ? getModifiedContractName(contractName, orderEntryData)
                      : selectedOption?.TermStructureDescription}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 7,
                    marginBottom: "20px",
                  }}
                >
                  <p
                    className="ion-no-margin text-bold"
                    style={{ fontSize: "var(--one-font-size-10)" }}
                  >
                    {componentusedIn == "marketData"
                      ? orderEntryData?.c
                      : getLastTwoWords(contractName)}
                  </p>
                  <div
                    className={`ob__side_sub-section ${side === "bid" ? `ob__side_type_buy` : `ob__side_type_sell`}`}
                  >
                    {side === "bid" ? "B" : "S"}
                  </div>
                </div>
                <div
                  style={{ marginBottom: "20px" }}
                  className="market_data-section"
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 2 }}
                  >
                    {tableHeaders.map((elem: string, id: number) => (
                      <div
                        key={id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                          backgroundColor: "#112B4A",
                          width: "25%",
                          justifyContent:
                            id === 1 || id === 3 ? "flex-end" : "flex-start",
                        }}
                      >
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-7)" }}
                        >
                          {elem}
                        </p>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 2 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        width: "25%",
                      }}
                    >
                      <p
                        className="ion-no-margin"
                        style={{ fontSize: "var(--one-font-size-7)" }}
                      >
                        {type === "options"
                          ? orderEntryData_Live?.bb?.f
                          : orderEntryData_Live?.b?.f}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        width: "25%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <p
                        className="ion-no-margin"
                        style={{ fontSize: "var(--one-font-size-7)" }}
                      >
                        {type === "options"
                          ? orderEntryData_Live?.b?.f
                          : orderEntryData_Live?.bb?.f}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        width: "25%",
                      }}
                    >
                      <p
                        className="ion-no-margin"
                        style={{ fontSize: "var(--one-font-size-7)" }}
                      >
                        {orderEntryData_Live?.bo && orderEntryData_Live?.bo?.f}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        width: "25%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <p
                        className="ion-no-margin"
                        style={{ fontSize: "var(--one-font-size-7)" }}
                      >
                        {orderEntryData_Live?.boq &&
                          orderEntryData_Live?.boq?.f}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="price-qty-section"
                  style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <div className="price-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      PRICE
                    </p>
                    <TickComponent
                      errorFlag={errorFlag}
                      handleChange={(e: any) =>
                        _updateGenericPriceInput(e, "price")
                      }
                      handleClick={debounce(
                        (obj: any) => _tickHandler(obj, "limitOrder"),
                        50,
                      )}
                      name={"Price"}
                      value={priceValue}
                      tickDisabled={
                        selectedOrderType === "2" ||
                        selectedOrderType === "4" ||
                        selectedOrderType === "8"
                          ? true
                          : false
                      }
                      priceDisabled={
                        selectedOrderType === "2" ||
                        selectedOrderType === "4" ||
                        selectedOrderType === "8"
                          ? true
                          : false
                      }
                      onBeforeInput={_beforePriceInput}
                      onFocusOut={(e: any) =>
                        formatPriceForScreen(
                          e,
                          "price",
                          priceType,
                          setpriceValue,
                          setStopPrice,
                        )
                      }
                      onFocus={(e: any) =>
                        removeCommasOnFocus(
                          e,
                          "price",
                          setpriceValue,
                          setStopPrice,
                          priceType,
                        )
                      }
                      onKeyUpPressFunc={(e: any) =>
                        onKeyUpPressHandler(e, "price")
                      }
                    />
                  </div>
                  <div className="qty-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      QUANTITY
                    </p>
                    <TickComponent
                      handleClick={_updateQuantity}
                      handleChange={_updateQuantityInput}
                      onBeforeInput={(event: any) => _handleKeyDownInput(event)}
                      name={"Quantity"}
                      value={quantity}
                      errorFlag={quantityErrorFlag}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", width: "100%", gap: "20px" }}>
                  <div style={{ width: "50%" }}>
                    <IonText color={"danger"}>
                      <p
                        className="ion-no-margin"
                        style={{
                          fontSize: "var(--one-font-size-8)",
                          marginTop: "5px",
                        }}
                      >
                        {errorMsg}
                      </p>
                    </IonText>
                  </div>
                  <div style={{ width: "50%" }}>
                    {quantityErrorFlag && (
                      <IonText color={"danger"}>
                        <p
                          className="ion-no-margin"
                          style={{
                            fontSize: "var(--one-font-size-8)",
                            marginTop: "5px",
                          }}
                        >
                          {quantityErrorMsg}
                        </p>
                      </IonText>
                    )}
                  </div>
                </div>
                <div
                  className="display-qty-toggle-section"
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div className="toggle-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      DISPLAY QUANTITY
                    </p>
                    <div
                      style={{ display: "flex", gap: 13, alignItems: "center" }}
                    >
                      <IonToggle
                        checked={isIceberg}
                        onIonChange={() => {
                          const newIsIceberg = !isIceberg;
                          setisIceberg(newIsIceberg);
                          if (newIsIceberg) {
                            validateDisclosedQuantity(
                              disclosedQuantity,
                              quantity,
                            );
                          } else {
                            setDisclosedQuantity(QUANTITY_LIMITS.MIN);
                            setDisclosedQuantityErrorFlag(false);
                            setDisclosedQuantityErrorMsg("");
                          }
                          hapticsImpactMedium();
                        }}
                        mode="md"
                      ></IonToggle>
                      <p
                        className="ion-no-margin text-bold"
                        style={{ fontSize: "var(--one-font-size-6)" }}
                      >
                        {isIceberg ? "TURN OFF" : "TURN ON"}
                      </p>
                    </div>
                  </div>
                  <div className="display-qty-section" style={{ width: "50%" }}>
                    {isIceberg ? (
                      <TickComponent
                        onBeforeInput={(event: any) =>
                          _handleKeyDownInput(event)
                        }
                        handleClick={_updateDisclosedQuantity}
                        handleChange={_updateDisclosedQuantityInput}
                        name={"Quantity"}
                        value={disclosedQuantity}
                        errorFlag={disclosedQuantityErrorFlag}
                      />
                    ) : (
                      <EmptyTickComponent />
                    )}
                  </div>
                </div>
                <div style={{ display: "flex", width: "100%", gap: "20px" }}>
                  <div style={{ width: "50%" }}></div>
                  <div style={{ width: "50%" }}>
                    {disclosedQuantityErrorFlag && (
                      <IonText color={"danger"}>
                        <p
                          className="ion-no-margin"
                          style={{
                            fontSize: "var(--one-font-size-8)",
                            marginTop: "5px",
                            position: "relative",
                            top: "-20px",
                          }}
                        >
                          {disclosedQuantityErrorMsg}
                        </p>
                      </IonText>
                    )}
                  </div>
                </div>
                <div
                  className="ordertype-stopprice-section"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <div className="ordertype-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      ORDER TYPE
                    </p>
                    <div
                      onClick={
                        orderType?.data?.length === 0
                          ? undefined
                          : handleOpenOrderType
                      }
                      style={{
                        display: "flex",
                        height: "41px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        padding: "12px 16px",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        border: "1px solid rgba(255, 255, 255, 0.10)",
                        ...(orderType?.data?.length === 0 && {
                          opacity: 0.5,
                          pointerEvents: "none",
                        }),
                      }}
                    >
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          wordBreak: "break-all",
                        }}
                      >
                        <p
                          className="ion-no-margin"
                          style={{
                            fontSize: "var(--one-font-size-10)",
                          }}
                        >
                          {(() => {
                            if (orderType?.data?.length === 0) {
                              return "No Data";
                            }
                            const displayText =
                              orderType?.data?.find(
                                (obj: any) => obj?.id === selectedOrderType,
                              )?.desc || selectedOrderType;
                            if (
                              displayText === "Market with Protection" ||
                              displayText === "Stop with Protection"
                            ) {
                              return displayText.replace("with", "w/");
                            }
                            return displayText;
                          })()}
                        </p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <IonIcon
                          icon={expandIcon}
                          style={{ height: "20px", width: "20px" }}
                        />
                      </div>
                    </div>
                    <IonSelect
                      interface="action-sheet"
                      value={selectedOrderType}
                      onIonChange={(e: any) => {
                        onChangeOrderType(e);
                        hapticsImpactMedium();
                      }}
                      ref={selectedOrderTypeRef}
                      className="ion-hide"
                    >
                      {componentusedIn === "optionsGrid" ? (
                        <>
                          <IonSelectOption value="1">Limit</IonSelectOption>
                          <IonSelectOption value="2">
                            Market with Protection
                          </IonSelectOption>
                          <IonSelectOption value="4">
                            Market-Limit
                          </IonSelectOption>
                        </>
                      ) : (
                        <>
                          {orderType?.data?.map((orderType: any) => {
                            return (
                              <IonSelectOption value={orderType?.id}>
                                {orderType?.desc}
                              </IonSelectOption>
                            );
                          })}
                        </>
                      )}
                    </IonSelect>
                  </div>
                  <div className="stopprice-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      STOP PRICE
                    </p>
                    {selectedOrderType === "8" || selectedOrderType === "16" ? (
                      <TickComponent
                        errorFlag={
                          stopPriceErrorMsgFlag ||
                          stopPriceValidationErrorMsgFlag
                        }
                        handleChange={(e) =>
                          _updateGenericPriceInput(e, "stopPrice")
                        }
                        handleClick={debounce(
                          (obj: any) => _tickHandler(obj, "stopOrder"),
                          50,
                        )}
                        name={"Stop Price"}
                        value={stopPrice}
                        onBeforeInput={_beforePriceInput}
                        onFocusOut={(e: any) =>
                          formatPriceForScreen(
                            e,
                            "stopPrice",
                            priceType,
                            setpriceValue,
                            setStopPrice,
                          )
                        }
                        onFocus={(e: any) =>
                          removeCommasOnFocus(
                            e,
                            "stopPrice",
                            setpriceValue,
                            setStopPrice,
                            priceType,
                          )
                        }
                        onKeyUpPressFunc={(e: any) =>
                          onKeyUpPressHandler(e, "stopPrice")
                        }
                      />
                    ) : (
                      <EmptyTickComponent />
                    )}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div style={{ width: "50%" }}></div>
                  <div style={{ width: "50%" }}>
                    {(selectedOrderType === "8" ||
                      selectedOrderType === "16") &&
                      stopPriceErrorMsgFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {stopPriceErrorMsg}
                          </p>
                        </IonText>
                      )}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div style={{ width: "50%" }}></div>
                  <div style={{ width: "50%" }}>
                    {(selectedOrderType === "8" ||
                      selectedOrderType === "16") &&
                      stopPriceValidationErrorMsgFlag &&
                      !errorFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {stopPriceValidationErrorMsg}
                          </p>
                        </IonText>
                      )}
                  </div>
                </div>
                <div
                  className="tif-date-section"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <div className="tif-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      TIME IN FORCE
                    </p>
                    <div
                      onClick={
                        tifs?.data?.length === 0 ? undefined : handleOpenTIF
                      }
                      style={{
                        display: "flex",
                        height: "41px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        padding: "12px 16px",
                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                        border: "1px solid rgba(255, 255, 255, 0.10)",
                        ...(tifs?.data?.length === 0 && {
                          opacity: 0.5,
                          pointerEvents: "none",
                        }),
                      }}
                    >
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          wordBreak: "break-all",
                        }}
                      >
                        <p
                          className="ion-no-margin"
                          style={{
                            fontSize: "var(--one-font-size-10)",
                          }}
                        >
                          {tifs?.data?.length === 0
                            ? "No Data"
                            : tifs?.data?.find(
                                (obj: any) => obj?.id === selectedTif,
                              )?.desc || selectedTif}
                        </p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <IonIcon
                          icon={expandIcon}
                          style={{ height: "20px", width: "20px" }}
                        />
                      </div>
                    </div>
                    <IonSelect
                      interface="action-sheet"
                      value={selectedTif}
                      onIonChange={(e: any) => {
                        updateTif(e.detail.value);
                        hapticsImpactMedium();
                      }}
                      ref={selectedTIFRef}
                      className="ion-hide"
                    >
                      {tifs?.data?.map((tif: any) => {
                        return (
                          <IonSelectOption value={tif?.id}>
                            {tif?.desc}
                          </IonSelectOption>
                        );
                      })}
                    </IonSelect>
                  </div>
                  <div className="date-section" style={{ width: "50%" }}>
                    <p
                      className="ion-no-margin text-bold"
                      style={{
                        fontSize: "var(--one-font-size-6)",
                        marginBottom: "10px",
                      }}
                    >
                      DATE
                    </p>
                    {selectedTif === "4" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          height: "41px",
                          background: "rgba(255, 255, 255, 0.05)",
                          border: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        <IonDatetimeButton
                          datetime="expiry_date_modal"
                          onClick={() => hapticsImpactMedium()}
                        ></IonDatetimeButton>
                        <IonModal keepContentsMounted={true}>
                          <IonDatetime
                            id="expiry_date_modal"
                            presentation="date"
                            showDefaultButtons={true}
                            value={expiryDate}
                            min={`${formatDate(today, "ISODATE")}`}
                            max={`${formatDate(allFutureDates, "ISODATE")}`}
                            isDateEnabled={isStartDateBlock}
                            onIonChange={(e: any) => {
                              _handleDateChange(e.detail.value);
                              hapticsImpactMedium();
                            }}
                          ></IonDatetime>
                        </IonModal>
                      </div>
                    ) : (
                      <EmptyDateComponent />
                    )}
                  </div>
                </div>
                <div
                  className="account-defaultacc_toggle-wrapper-section"
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <p
                    className="ion-no-margin text-bold"
                    style={{
                      fontSize: "var(--one-font-size-6)",
                      marginBottom: "10px",
                    }}
                  >
                    ACCOUNT
                  </p>
                  <div
                    className="account-defaultacc_toggle-section"
                    style={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div className="account-section" style={{ width: "50%" }}>
                      <div
                        onClick={
                          accounts?.data?.length === 0
                            ? undefined
                            : handleOpenAccount
                        }
                        style={{
                          display: "flex",
                          height: "41px",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          padding: "12px 16px",
                          backgroundColor: accountErrorMessage
                            ? "rgba(232, 61, 61, 0.086)"
                            : "rgba(255, 255, 255, 0.05)",
                          border: "1px solid rgba(255, 255, 255, 0.10)",
                          ...(accounts?.data?.length === 0 && {
                            opacity: 0.5,
                            pointerEvents: "none",
                          }),
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                          }}
                        >
                          {selectedAccount &&
                            userPreferences.defaultaccount.replace(/"/g, "") ===
                              selectedAccount && (
                              <IonIcon
                                icon={star}
                                color="warning"
                                style={{
                                  height: "15px",
                                  width: "15px",
                                }}
                              />
                            )}
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              wordBreak: "break-all",
                            }}
                          >
                            <p
                              className="ion-no-margin"
                              style={{
                                fontSize: "var(--one-font-size-10)",
                              }}
                            >
                              {accounts?.data?.length === 0
                                ? "No Data"
                                : accounts?.data?.find(
                                    (obj: any) => obj?.id === selectedAccount,
                                  )?.desc || "Select an account"}
                            </p>
                          </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <IonIcon
                            icon={expandIcon}
                            style={{ height: "20px", width: "20px" }}
                          />
                        </div>
                      </div>
                      <IonSelect
                        label={"Account"}
                        interface="action-sheet"
                        placeholder={
                          accounts?.isLoading && openOrderEntryModal
                            ? "Loading..."
                            : "Select an account"
                        }
                        justify="space-between"
                        onIonChange={(e: any) => {
                          setselectedAccount(e.detail.value);
                          setAccountErrorMessage("");
                          hapticsImpactMedium();
                        }}
                        value={selectedAccount}
                        disabled={
                          accounts?.data?.length === 0 ||
                          (accounts?.isLoading && openOrderEntryModal)
                        }
                        ref={selectedAccountRef}
                        className="ion-hide"
                      >
                        {accounts?.data?.map((account: any) => {
                          return (
                            <IonSelectOption value={account?.id}>
                              {account?.desc}
                            </IonSelectOption>
                          );
                        })}
                      </IonSelect>
                      {accountErrorMessage && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {accountErrorMessage}
                          </p>
                        </IonText>
                      )}
                    </div>
                    <div className="toggle-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        MAKE MY DEFAULT ACCOUNT
                      </p>
                      <div
                        style={{
                          display: "flex",
                          gap: 13,
                          alignItems: "center",
                        }}
                      >
                        <IonToggle
                          onIonChange={(e: any) => {
                            handleSaveDefaultAccount(e);
                            hapticsImpactMedium();
                          }}
                          disabled={
                            accounts?.data?.length === 0 ||
                            (accounts?.isLoading && openOrderEntryModal) ||
                            selectedAccount === undefined
                          }
                          checked={
                            userPreferences.defaultaccount.replace(/"/g, "") ===
                            selectedAccount
                          }
                          mode="md"
                        ></IonToggle>
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-6)" }}
                        >
                          {userPreferences.defaultaccount.replace(/"/g, "") ===
                          selectedAccount
                            ? "YES"
                            : "NO"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {userCMEDEntitlements?.showNotes && (
                  <>
                    <div
                      className="notes-section"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <div className="notes-section" style={{ width: "100%" }}>
                        <p
                          className="ion-no-margin text-bold"
                          style={{
                            fontSize: "var(--one-font-size-6)",
                            marginBottom: "10px",
                          }}
                        >
                          NOTES
                        </p>
                        <div
                          style={{
                            display: "flex",
                            height: "41px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "12px 16px",
                            border: "1px solid rgba(255, 255, 255, 0.10)",
                            backgroundColor: notesErrorFlag
                              ? "rgba(232, 61, 61, 0.086)"
                              : "rgba(255, 255, 255, 0.05)",
                          }}
                        >
                          <IonInput
                            placeholder="Add notes here"
                            type="text"
                            inputmode="text"
                            value={notes}
                            onIonInput={(e: any) => {
                              _updateNotesInput(e);
                            }}
                          ></IonInput>
                        </div>
                      </div>
                    </div>
                    <div style={{ width: "100%" }}>
                      {notesErrorFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            Maximum notes limit is upto 50 characters
                          </p>
                        </IonText>
                      )}
                    </div>
                  </>
                )}
              </div>
            </IonContent>
            <IonFooter
              className="ion-no-padding ion-no-border"
              style={{ marginBottom: "20px" }}
            >
              <IonGrid className="ion-padding">
                <IonRow>
                  <IonCol size="6">
                    <IonButton
                      className="custom_cmed_mobile_button"
                      fill="outline"
                      expand="block"
                      color={side === "offer" ? "primary" : "danger"}
                      onClick={() => {
                        hapticsImpactMedium();
                        if (side === "bid") {
                          setSide("offer");
                          switch (componentusedIn) {
                            case "optionsGrid":
                              CMEDfirebaseLogEvent(
                                firebaseEventConfig.CMEDComponentNames
                                  .CMED_OPTIONS_GRID,
                                firebaseEventConfig.eventNames.CMED_OPTIONS_GRID
                                  .CMED_OPTIONS_GRID_SWITCH_TO_OFFER,
                              );
                              break;
                            case "marketData":
                              CMEDfirebaseLogEvent(
                                firebaseEventConfig.CMEDComponentNames
                                  .CMED_MARKET_DATA,
                                firebaseEventConfig.eventNames.CMED_MARKET_DATA
                                  .CMED_MARKET_DATA_SWITCH_TO_OFFER,
                              );
                              break;
                            default:
                              break;
                          }
                        } else {
                          setSide("bid");
                          switch (componentusedIn) {
                            case "optionsGrid":
                              CMEDfirebaseLogEvent(
                                firebaseEventConfig.CMEDComponentNames
                                  .CMED_OPTIONS_GRID,
                                firebaseEventConfig.eventNames.CMED_OPTIONS_GRID
                                  .CMED_OPTIONS_GRID_SWITCH_TO_BID,
                              );
                              break;
                            case "marketData":
                              CMEDfirebaseLogEvent(
                                firebaseEventConfig.CMEDComponentNames
                                  .CMED_MARKET_DATA,
                                firebaseEventConfig.eventNames.CMED_MARKET_DATA
                                  .CMED_MARKET_DATA_SWITCH_TO_BID,
                              );
                              break;
                            default:
                              break;
                          }
                        }
                      }}
                    >
                      SWITCH TO {side === "offer" ? "BID" : "OFFER"}
                    </IonButton>
                  </IonCol>
                  <IonCol size="6">
                    <IonButton
                      className="custom_cmed_mobile_button"
                      color={side === "bid" ? "primary" : "danger"}
                      onClick={() => handleOrderEntry()}
                      expand="block"
                      fill="solid"
                      disabled={
                        priceValueLoadingErrorState?.isLoading ||
                        accounts?.isLoading ||
                        tifs?.isLoading
                      }
                    >
                      SUBMIT {side === "bid" ? "BID" : "OFFER"}
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonFooter>
          </Fragment>
        )}
      </IonModal>
      <IonAlert
        className="one-alert"
        isOpen={isOrderConfirmationAlertOpen}
        header={orderConfirmationPopup()}
        message={`Are you sure you want to ${
          side?.toLocaleUpperCase() === "BID" ? "buy" : "sell"
        }?`}
        onDidDismiss={() => setIsOrderConfirmationAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              submitOrderRequest();
            },
          },
        ]}
      ></IonAlert>
      <IonToast
        isOpen={isDefaultAccountSaved}
        message="Default account is set."
        onDidDismiss={() => setIsDefaultAccountSaved(false)}
        duration={5000}
        color="success"
        icon={checkmarkCircleOutline}
        buttons={[
          {
            text: "Dismiss",
            role: "cancel",
          },
        ]}
      ></IonToast>
      <IonToast
        isOpen={isDefaultAccountDeleted}
        message="Default account is deleted."
        onDidDismiss={() => setIsDefaultAccountDeleted(false)}
        duration={5000}
        color="success"
        icon={checkmarkCircleOutline}
        buttons={[
          {
            text: "Dismiss",
            role: "cancel",
          },
        ]}
      ></IonToast>
    </React.Fragment>
  );
};

export default memo(OrderEntryModal);
